import type { HttpTransport } from "@common/api/transport";

type FirstPromoterProfileParams = {
  campaign: string;
};

type FirstPromoterProfileResponse = {
  firstPromoterAuthToken: string | null;
};

export const createFirstPromoterApi = (http: HttpTransport) => ({
  createUsersFirstPromoterProfile: ({ campaign }: FirstPromoterProfileParams) =>
    http.post<FirstPromoterProfileResponse>("/api/users/first_promoter_profile", {
      firstPromoterProfile: { campaign }
    })
});
